import React from "react"
import {useAccessToken} from "../../../../services/auth"
import useAsyncResultIdle from "../../../../hooks/useAsyncResultIdle"

import {Application, resubmitBeneficialOwnerBusinessApplication} from "../../../../resources/application"
import ConfirmationModalContent from "../ConfirmationModalContent"
import {ReevaluatedBeneficialOwnerApplicationData} from "../../Forms/ReevaluateBeneficialOwnerForm/ReevaluateBeneficialOwnerForm"
import {BeneficialOwnerResource} from "../../../../resources/beneficialOwner"

export default function ReevaluateBeneficialOwnerConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	application: Application
	beneficialOwnerResource: BeneficialOwnerResource
	enableReevaluateApplication: boolean
	reevaluatedData: ReevaluatedBeneficialOwnerApplicationData
}) {
	const {close, onSuccess, application, beneficialOwnerResource, enableReevaluateApplication, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateBeneficialOwnerRequest, setUpdateBeneficialOwnerRequest] = useAsyncResultIdle(
		resubmitBeneficialOwnerBusinessApplication
	)

	const handleSubmit = (reason: string) => {
		const data = {
			dateOfBirth: reevaluatedData.dateOfBirth,
			ssn: reevaluatedData.ssn,
			email: reevaluatedData.email,
			phone: reevaluatedData.phone,
			address: reevaluatedData.address,
			passport: reevaluatedData.passport,
			fullName: reevaluatedData.fullName,
			nationality: reevaluatedData.nationality,
			reasonText: reason,
			matriculaConsular: reevaluatedData.matriculaConsular,
			percentage: reevaluatedData.percentage,
		}

		setUpdateBeneficialOwnerRequest(accessToken, application, beneficialOwnerResource, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateBeneficialOwnerRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={enableReevaluateApplication}
		/>
	)
}
